export const API_BASE_URL = 'https://vue-moire.skillbox.cc';
